export default __webpack_public_path__ + "static/media/telegram-5945.498e1a72.svg";